export const SMV_RSP_BLUEPRINT_ID = '1';
export const SMV_RS_BLUEPRINT_NAME = '2';
export const MVP_BLUEPRINT_ID = '3';

export const INSIGHT_TYPES_OPTIONS = [
    { value: 'smv', label: 'YoY SMV Benchmarking' },
    { value: 'mvp', label: 'MVP % Evaluation' },
];
